const types = {
  OPEN: 'app/drawer/OPEN',
  CLOSED: 'app/drawer/CLOSED',
  SET: 'app/drawer/SET',
};

export default types;
